import React from "react";
import { ImageGeneratorDenimTile } from "../../app/api/imageGenerator";
import ImageGeneratorPreferenceTile from "./ImageGeneratorPreferenceTile";
import {
  RequiredMark,
  sectionClassName,
  sectionTitleClassName,
} from "./ImageGeneratorControls";

type Props = {
  materials: ImageGeneratorDenimTile[];
  washes: ImageGeneratorDenimTile[];
  selectedMaterialId: string;
  selectedWashId: string;
  materialPreviews: Record<string, string>;
  washPreviews: Record<string, string>;
  showMaterials: boolean;
  showWashes: boolean;
  onSelectMaterial: (id: string) => void;
  onSelectWash: (id: string) => void;
};

const ImageGeneratorDenimSections: React.FC<Props> = ({
  materials,
  washes,
  selectedMaterialId,
  selectedWashId,
  materialPreviews,
  washPreviews,
  showMaterials,
  showWashes,
  onSelectMaterial,
  onSelectWash,
}) => (
  <>
    {showMaterials ? (
      <div className={sectionClassName}>
        <h2 className={`${sectionTitleClassName} mb-3`}>
          Select Denim Materials
          <RequiredMark />
        </h2>
        <div className="flex flex-wrap gap-3 sm:gap-4">
          {materials.map(item => (
            <div
              key={item.id}
              className="w-[calc((100%-0.75rem)/2)] max-w-[176px] sm:w-[176px]"
            >
              <ImageGeneratorPreferenceTile
                asset={{ stem: item.id, available: true, url: item.url }}
                previewUrl={
                  materialPreviews[item.id] ||
                  (/^https?:\/\//i.test(item.url) ? item.url : undefined)
                }
                isSelected={selectedMaterialId === item.id}
                choiceLocked={false}
                isMuted={
                  Boolean(selectedMaterialId) && selectedMaterialId !== item.id
                }
                caption={item.label}
                aspectClassName="aspect-[2/3]"
                imageFit="contain"
                onToggle={onSelectMaterial}
              />
            </div>
          ))}
        </div>
      </div>
    ) : null}
    {showWashes ? (
      <div className={sectionClassName}>
        <h2 className={`${sectionTitleClassName} mb-3`}>
          Select Denim washes
          <RequiredMark />
        </h2>
        <div className="grid w-full grid-cols-8 gap-1.5 sm:gap-2 md:gap-2.5">
          {washes.map(item => (
            <div key={item.id} className="min-w-0 w-full">
              <ImageGeneratorPreferenceTile
                asset={{ stem: item.id, available: true, url: item.url }}
                previewUrl={
                  washPreviews[item.id] ||
                  (/^https?:\/\//i.test(item.url) ? item.url : undefined)
                }
                isSelected={selectedWashId === item.id}
                choiceLocked={false}
                isMuted={Boolean(selectedWashId) && selectedWashId !== item.id}
                caption={item.label}
                aspectClassName="aspect-square"
                imageFit="cover"
                onToggle={onSelectWash}
              />
            </div>
          ))}
        </div>
      </div>
    ) : null}
  </>
);

export default ImageGeneratorDenimSections;
